import React from 'react';
import { ChevronDown, Plus } from 'lucide-react';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import ListEditor from './ListEditor';

function ServiceRow({ s, i, onChange, disabled }) {
  const [open, setOpen] = React.useState(false);
  const set = (patch) => onChange(i, { ...s, ...patch });
  return (
    <div className={`rounded-xl border ${s.selected ? 'border-fuchsia-200 bg-fuchsia-50/40' : 'border-slate-200 bg-white'}`} data-testid={`service-row-${i}`}>
      <div className="flex items-center gap-3 px-3 py-2.5">
        <input type="checkbox" checked={!!s.selected} disabled={disabled} onChange={(e) => set({ selected: e.target.checked })}
          className="w-4 h-4 accent-fuchsia-600" data-testid={`service-check-${i}`} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-slate-800">{s.area || 'Untitled service'}</p>
          <p className="text-xs text-slate-500 truncate">{s.included}</p>
        </div>
        <button type="button" onClick={() => setOpen(!open)} className="p-1.5 rounded-lg hover:bg-white" data-testid={`service-expand-${i}`} aria-label="Edit">
          <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
      </div>
      {open && (
        <div className="px-3 pb-3 space-y-2 border-t border-slate-100 pt-3">
          <Input value={s.area} disabled={disabled} onChange={(e) => set({ area: e.target.value })} placeholder="Area" data-testid={`service-area-${i}`} />
          <Textarea value={s.included} rows={2} disabled={disabled} onChange={(e) => set({ included: e.target.value })} placeholder="What is included" data-testid={`service-included-${i}`} />
          <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wide">Deliverables (optional bullets)</p>
          <ListEditor value={s.deliverables || []} disabled={disabled} rows={1} onChange={(d) => set({ deliverables: d })} addLabel="Add deliverable" testId={`service-deliverables-${i}`} />
        </div>
      )}
    </div>
  );
}

export default function ServicesChecklist({ value = [], onChange, disabled }) {
  const update = (i, s) => onChange(value.map((x, j) => (j === i ? s : x)));
  const picked = value.filter((s) => s.selected).length;
  return (
    <div className="space-y-2" data-testid="services-checklist">
      <p className="text-xs text-slate-500">{picked} of {value.length} services included in Schedule A. Edits here apply only to this document.</p>
      {value.map((s, i) => <ServiceRow key={i} s={s} i={i} onChange={update} disabled={disabled} />)}
      {!disabled && (
        <button type="button" onClick={() => onChange([...value, { area: 'New service', included: '', deliverables: [], selected: true }])}
          className="inline-flex items-center gap-1 text-xs font-semibold text-fuchsia-700" data-testid="service-add-custom">
          <Plus className="w-3.5 h-3.5" /> Add a one-off service
        </button>
      )}
    </div>
  );
}
